import './video-player.scss'

const initVideoPlayers = () => {
	const players = document.querySelectorAll( '[data-video-player]' );

	if ( ! players.length ) {
		return;
	}

	const buildYoutubeSrc = ( base ) => {
		if ( ! base ) {
			return '';
		}

		const separator = base.includes( '?' ) ? '&' : '?';
		return `${ base }${ separator }autoplay=1&rel=0&modestbranding=1`;
	};

	players.forEach( ( player ) => {
		const toggle = player.querySelector( '[data-video-toggle]' );
		const wrapper = player.querySelector( '[data-video-wrapper]' );
		const iframe = player.querySelector( '[data-video-iframe]' );
		const video = player.querySelector( '[data-video-element]' );

		if ( ! toggle || ! wrapper || ( ! iframe && ! video ) ) {
			return;
		}

		const startPlayback = () => {
			if ( player.classList.contains( 'is-playing' ) ) {
				return;
			}

			if ( iframe ) {
				const source = iframe.dataset.videoSrc;
				if ( source && ! iframe.src ) {
					iframe.src = buildYoutubeSrc( source );
				}
			} else if ( video ) {
				if ( video.paused ) {
					const playPromise = video.play();
					if ( playPromise !== undefined ) {
						playPromise.catch( () => {} );
					}
				}
			}

			wrapper.removeAttribute( 'hidden' );
			wrapper.setAttribute( 'aria-hidden', 'false' );
			player.classList.add( 'is-playing' );
			toggle.setAttribute( 'aria-expanded', 'true' );
			toggle.setAttribute( 'aria-hidden', 'true' );
			toggle.disabled = true;
			if ( iframe ) {
				iframe.focus();
			} else if ( video ) {
				video.setAttribute( 'controls', 'controls' );
				video.focus();
			}
		};

		toggle.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			startPlayback();
		} );

		toggle.addEventListener( 'keydown', ( event ) => {
			if ( ( event.key === 'Enter' || event.key === ' ' ) && ! player.classList.contains( 'is-playing' ) ) {
				event.preventDefault();
				startPlayback();
			}
		} );
	} );
};

document.addEventListener( 'DOMContentLoaded', initVideoPlayers );

